{
  "ASSISTANT_NOT_CONFIGURED": "O assistente ainda não está configurado nesta área",
  "ASSISTANT_CONVERSATION_NOT_FOUND": "Conversa não encontrada",
  "ASSISTANT_CONVERSATION_DELETED": "Conversa apagada",
  "ASSISTANT_MESSAGE_REQUIRED": "Escreva uma mensagem ou anexe um arquivo",
  "ASSISTANT_RUN_IN_PROGRESS": "O assistente ainda está respondendo nesta conversa",
  "ASSISTANT_RUN_FAILED": "O assistente teve um problema ao responder",
  "ASSISTANT_APPROVAL_NOT_PENDING": "Esta confirmação não está mais pendente",
  "ASSISTANT_UPLOAD_NOT_FOUND": "Arquivo não encontrado nesta conversa",
  "ASSISTANT_UPLOAD_TYPE_INVALID": "Tipo de arquivo não aceito",
  "ASSISTANT_UPLOAD_TOO_LARGE": "Arquivo maior que o permitido",
  "ASSISTANT_UPLOAD_INCOMPLETE": "O arquivo ainda não terminou de subir",
  "ASSISTANT_UPLOAD_NOT_RETRYABLE": "Este arquivo já foi recebido",
  "ASSISTANT_UPLOAD_FAILED": "Não foi possível processar o arquivo"
}
